"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var MaterialCommunityIcons_1 = __importDefault(require("react-native-vector-icons/dist/MaterialCommunityIcons"));

var styled_components_1 = require("styled-components");

var defaultColor = '#562685';
var IconSizeEnum;

(function (IconSizeEnum) {
  IconSizeEnum["xSmall"] = "xSmall";
  IconSizeEnum["small"] = "small";
  IconSizeEnum["medium"] = "medium";
  IconSizeEnum["large"] = "large";
})(IconSizeEnum = exports.IconSizeEnum || (exports.IconSizeEnum = {}));

var sizes = (_a = {}, _a[IconSizeEnum.xSmall] = 12, _a[IconSizeEnum.small] = 20, _a[IconSizeEnum.medium] = 32, _a[IconSizeEnum.large] = 48, _a);
var defaultIconSize = 16;

var Icon =
/** @class */
function (_super) {
  __extends(Icon, _super);

  function Icon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Icon.prototype.render = function () {
    var _a = this.props,
        name = _a.name,
        size = _a.size,
        color = _a.color,
        theme = _a.theme;
    var iconSize = sizes[size];
    var iconColor = color ? color : theme && theme.colors.purple || defaultColor;
    return react_1.default.createElement(MaterialCommunityIcons_1.default, {
      name: name,
      size: iconSize || defaultIconSize,
      color: iconColor
    });
  };

  Icon.IconSize = IconSizeEnum;
  return Icon;
}(react_1.Component);

exports.Icon = Icon;
exports.default = styled_components_1.withTheme(Icon);